
// Last character of CodeNext
// A = automatic
// M = manual

// * What status is an encounter currently in, or
// * What status should we submit it to?
// * If the encounter shows up on the dashboard with a CodeNext,
//   what can the user do with it?
export enum CodeNext {
	// clinician has not started the scheduled encounter
	// user can view, start (POPSTART_M), cancel (POPCANCELA) encounter
	NotStarted = 'CRECMLPTEM',
	// clinician is canceling / has cancelled encounter
	// prior to starting it
	// user can view encounter
	// (but it wont be visible on dashboard)
	Cancelled = 'POPCANCELA',
	// clinician is starting / is working the encounter
	// user can view, continue, complete (POPCMLPTEA), cancel (POPCANCELA) encounter
	InProgress = 'POPSTART_M',
	// clinician is submitting / has submitted the encounter
	// user can view encounter
	Completed = 'POPCMLPTEA',
	// auditor is reviewing the encounter submitted by clinician
	// user can view, continue, query clinician (AUDCLNCANM), complete (AUDL1CMPLA) encounter
	Level1Audit = 'AUDAUDIT_M',
	// auditor is submitting queries back to the clinician
	// clinician is reviewing the queries submitted by auditor
	// user can view, continue, re-complete (AUDAUDIT_M) encounter
	ClinicianAuditReview = 'AUDCLNCANM',
	// auditor is submitting the completed audit
	// user can view encounter
	Audit1ToComplete = 'AUDL1CMPLA',
	// collaborating physician is reviewing the encounter
	// user can view, continue, complete (APPCPSENTM) encounter
	CollaboratingPhysicianPending = 'APPCPPENDM',
	// collaborating physician is submitting / has submitted the encounter
	// user can view encounter
	CollaboratingPhysicianSubmitted = 'APPCPSENTM',
	// clinician is reviewing returned lab results on a previously submitted encounter
	// user can view, continue, re-complete (PSMFRMAUDA) encounter
	PostSubmitLabClinician = 'PSMLABCLNM',
	// clinician is submitting the completed review of returned lab results
	// OR waiting in queue for dan's system to process (up to 15 minutes)
	// i.e. between Completed and Level1Audit
	// user can view encounter
	PostSubmitFormAudit = 'PSMFRMAUDA',
	// encounter has been #sploded
	// user can view encounter
	// (but it wont be visible on dashboard)
	Voided = 'POPVOIDEDF',
}

export type UnvalidatedCodeNext = CodeNext|string

export const isCodeNext = (value: UnvalidatedCodeNext): value is CodeNext => {
	return Object.values(CodeNext).includes(value as CodeNext)
}

